import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_false, assert_not_null, not_implemented } from '@shared/asserts/utils_asserts';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { DTO_META__field_info } from '../../_base/DTO_META__field_info';
import { FIELD__base_visible_connectable } from '../../_base/FIELD__base_connectable';
import { DECORATOR__field_is_input } from './DECORATOR__field_is_input';
import { DECORATOR__field_not_linked } from './DECORATOR__field_not_linked';

export class FIELD_PRIMITIVE__base extends FIELD__base_visible_connectable {
  /*
   * STATIC METHODS
   */

  static get_meta_params_default(): Partial<DTO_META__field_info> {
    let out = super.get_meta_params_default();

    out.grid2d__can_be_dimension = true;

    return out;
  }

  /*
   * FIELDS
   */
  value!: any;
  value_range!: any;
  values_allowed!: any;

  /*
   * VALUE
   */

  field_connectable__value(graph: DTO_GRAPH__instance): string {
    if (this.meta.kind__is_output) return 'computed';
    if (this.meta.data__is_linked) return 'linked';

    return `${this.get_value()}`;
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  get_value(): any {
    not_implemented();
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  set_value(value_new: any) {
    not_implemented();
  }

  /*
   * VALUE RANGE
   */

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  get_value_range(): any {
    not_implemented();
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  set_value_range(value_new: any) {
    not_implemented();
  }

  /*
   * VALUES ALLOWED
   */
  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  get_values_allowed(): any {
    not_implemented();
  }

  /*
   * EVENTS
   */

  /*
   * METHODS
   */

  constructor() {
    super();
  }

  /*
   * SYNC
   */

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  grid2d_dimension__set_value(value: any) {
    assert_false(this.meta.data__is_linked);
    this.set_value(value);
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  grid2d_dimension__apply_for(graph: DTO_GRAPH__instance) {
    assert_false(this.meta.data__is_linked);
    graph.field__replace(this);
  }

  /*
   * HASH
   */

  /*
   * VALIDATINS
   */
  override _validate__case_base(graph: DTO_GRAPH__instance) {
    if (this.meta.kind__is_output) return;

    if (this.value == null) this.error_add(ENUM__error_type.GRAPH_FIELD__VALUE_CANT_BE_NULL);
    if (this.value_range == null) this.error_add(ENUM__error_type.GRAPH_FIELD__VALUE_RANGE_CANT_BE_NULL);

    if (this.values_allowed == null) this.error_add(ENUM__error_type.GRAPH_FIELD__VALUES_ALLOWED_CANT_BE_NULL);
  }

  /*
   *
   */

  /*
   * SHARING
   */

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  store__serialization_keys_list_white_for_hash(): string[] {
    let out: (keyof this)[] = [];

    out.push('value');

    return out as string[];
  }

  /*
   *
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_not_null(this.values_allowed);
  }

  assert_standard_fields_with_value(): void {
    super.assert_standard_fields_with_value();
    assert_not_null(this.value);
    assert_not_null(this.value_range);
  }
}
